export const persistenceMiddleware = (store) => (next) => (action) => {
    const result = next(action);
    const state = store.getState();

    // Customize the key and state slice to be persisted
    localStorage.setItem('reduxState', JSON.stringify(state));

    return result;
};